import React from 'react';
import Chat from '../chat/Chat';

const ChatInterface = () => {
  return <Chat userType="demenageur" />;
};

export default ChatInterface;
